import { queryOptions, skipToken } from '@tanstack/react-query'

import { importLocationProfiles, importLocationProfileSurgeryTypeGroups } from '~/store/di-entity.api.generated'

export const locationProfileQueries = {
    importAll: () =>
        queryOptions({
            queryKey: ['locationProfiles'],
            queryFn: () => Promise.all([importLocationProfiles({}), importLocationProfileSurgeryTypeGroups({})]),
        }),
    importByLocationId: (locationId?: number) =>
        queryOptions({
            queryKey: ['locationProfiles', locationId],
            queryFn:
                locationId !== undefined
                    ? () =>
                          Promise.all([
                              importLocationProfiles({ location_id: locationId }),
                              importLocationProfileSurgeryTypeGroups({
                                  'location_profile.location_id': locationId,
                              }),
                          ])
                    : skipToken,
        }),
}
